import { FC } from "react";
import styles from "./B2bSubscriptionEnded.module.scss";

interface Props {
    organizationName?: string;
    renewalDate?: string;
}

const B2bSubscriptionEnded: FC<Props> = ({
    organizationName = "your organization",
    renewalDate = "recently",
}) => {
    return (
        <div className="flex-1 bg-aha-green">
            <div className={styles.container}>
                <div className={styles.headerSection}>
                    <h1 className={styles.title}>We miss having you here!</h1>
                    <p className={styles.subtitle}>
                        It looks like{" "}
                        <span className={styles.organizationName}>
                            {organizationName}
                        </span>
                        's subscription ended{" "}
                        <span className={styles.subscriptionDate}>
                            {renewalDate}
                        </span>{" "}
                        and hasn't been renewed yet, so your account is
                        temporarily inactive.
                    </p>
                    <p className={styles.subtitle}>
                        What would you like to do?
                    </p>
                </div>

                <div className={styles.actionsSection}>
                    <div className={styles.actionCard}>
                        <div className={styles.actionHeader}>
                            <div className={styles.actionNumber}>1</div>
                            <h3 className={styles.actionTitle}>
                                Ask your admin to renew
                            </h3>
                        </div>
                        <p className={styles.actionDescription}>
                            Reach out to your organization's account owner to
                            get your subscription reactivated.
                        </p>
                    </div>

                    <div className={styles.actionCard}>
                        <div className={styles.actionHeader}>
                            <div className={styles.actionNumber}>2</div>
                            <h3 className={styles.actionTitle}>
                                See our plans & pricing
                            </h3>
                        </div>
                        <p className={styles.actionDescription}>
                            Explore individual pricing options to continue using
                            At Home Articulation on your own.
                        </p>
                    </div>
                </div>

                <div className={styles.supportSection}>
                    <h3 className={styles.supportTitle}>Need a hand?</h3>
                    <p className={styles.supportText}>
                        Our support team is ready to help you get back up and
                        running.
                    </p>
                    <div className={styles.contactInfo}>
                        <a
                            href="mailto:support@athomearticulation.com"
                            className={styles.contactLink}
                        >
                            support@athomearticulation.com
                        </a>
                        <a
                            href="tel:+18018086287"
                            className={styles.contactLink}
                        >
                            +1‑801-808-6287
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default B2bSubscriptionEnded;
